import React from 'react';
import Input from '@/components/General/inputs/Input';

/**
 * Renders `number` schema fields. Uses the shared `Input` with a decimal
 * keyboard type so mobile shows a numeric keypad. min/max/step validation is
 * enforced in `FormView` (client-side) and the submit edge function.
 */
const NumberField = ({ field, value, onChange, disabled }) => {
    return (
        <Input
            testID={`form-field-${field.fieldId}`}
            title={field.label}
            placeholder={field.placeholder}
            value={value == null ? '' : String(value)}
            onUpdate={(text) => {
                if(text === '' || text == null){
                    onChange(null);
                    return;
                }
                const num = Number(text);
                onChange(Number.isNaN(num) ? null : num);
            }}
            type="decimal"
            required={field.required}
            helpText={field.description}
            disabled={disabled}
            autoCapitalize="none"
            autoComplete="off"
        />
    );
};

export default NumberField;
